import React, { useEffect, useState } from "react";
import { monthNameAndYearStr } from "../../../common/functions";

import "../styles/GetPaymentsItem.css"

interface IGetPaymentsItem {
  period: string,
  setChoosedIdxs: React.Dispatch<React.SetStateAction<string[]>>
}

export const GetPaymentsItem = ({period, setChoosedIdxs}: IGetPaymentsItem) => {

  const [check, setCheck] = useState(false)
  useEffect(() => {
    
    setChoosedIdxs(prev => {
      let  copy = prev.slice(0)
      let idx = copy.indexOf(period)

      //@ts-ignore
      if(check && idx == -1) copy.push(period)
      //@ts-ignore
      else copy.splice(idx, 1)
     return copy
    })
  }, [check])
  return (
    <li className="a_o_gpi_tag_li">
      <div className="a_o_gpi_main_con">
      <label className="a_o_gpi_title">{monthNameAndYearStr(period)}</label>
      <input className="a_o_gpi_checkbox" type="checkbox"  checked={check} onChange={() => setCheck(!check)}></input>
      </div>
    </li>
  );
};
